import { getDateFormatShort } from '@libs/focus-frontend-services/src/PreferencesService/PreferencesService';

import { fromFormat } from './date';

export const parseMultiFormatsDate = (dateString: string) => {
  if (!dateString) {
    return null;
  }

  const ALLOWED_DATE_FORMATS = ['dd/MM/yyyy', 'yyyy-MM-dd', 'dd.MM.yyyy', 'dd-MM-yyyy', 'MM/dd/yyyy'];
  const MONTH_ALLOWED_DATE_FORMATS = ALLOWED_DATE_FORMATS.filter((format) => format.toLowerCase().startsWith('m'));

  if (getDateFormatShort().toLowerCase().startsWith('m')) {
    for (const format of MONTH_ALLOWED_DATE_FORMATS) {
      const parsedDate = fromFormat(dateString, format);
      if (parsedDate.isValid) {
        return parsedDate;
      }
    }
  }

  for (const format of ALLOWED_DATE_FORMATS) {
    const parsedDate = fromFormat(dateString, format);
    if (parsedDate.isValid) {
      return parsedDate;
    }
  }

  return null;
};
